import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {SettingsParkingPassesService} from '../../services/settings-parking-passes.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';

declare const $: any;

@Component({
    templateUrl: 'settings-parking-passes.component.html'
})
export class SettingsParkingPassesComponent implements OnInit, OnDestroy {
    $destroy = new Subject();
    spinnerShow = false;
    currentTabId: string = 'rules';
    tabTitles = {
        'rules': 'Rule',
        'lots': 'Lot'
    };

    constructor(public settingsParkingPassesService: SettingsParkingPassesService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.settingsParkingPassesService.getUserRoles();
        this.settingsParkingPassesService.getBuildings()
            .pipe(takeUntil(this.$destroy))
            .subscribe();
        this.settingsParkingPassesService.getParkingLots();

        this.urlService.getQueryParams();
        this.urlService.onUrlChange
            .pipe(
                tap(() => {
                    this.settingsParkingPassesService.showDetailedView = false;
                    this.settingsParkingPassesService.selectedItemData = null;
                    this.settingsParkingPassesService.currentTabId = this.currentTabId = this.urlService.queryParams['tab'];
                }),
                flatMap(
                    () => this.settingsParkingPassesService.getDataByQueryParams(true)
                        .pipe(takeUntil(this.urlService.instantOnUrlChange))
                )
            )
            .subscribe();

        this.settingsParkingPassesService
            .onDataSend
            .pipe(takeUntil(this.$destroy))
            .subscribe(() => this.spinnerShow = true);
        this.settingsParkingPassesService
            .onDataReceived
            .pipe(takeUntil(this.$destroy))
            .subscribe(data => {
                this.spinnerShow = false;
                if ($('.table')[0] && data.scrollToTop)
                    $('.table')[0].scrollIntoView();
            });
        this.settingsParkingPassesService
            .hideSpinner
            .pipe(takeUntil(this.$destroy))
            .subscribe(() => this.spinnerShow = false);

        const tabId = this.currentTabId = this.urlService.queryParams.tab || 'rules';
        this.urlService.setQueryParams(tabId);
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.settingsParkingPassesService.resetData();
        this.urlService.resetQueryParams();
        this.$destroy.next();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    getActiveTabTitle() {
        const tabId = this.urlService.queryParams['tab'];
        return this.tabTitles[tabId] ? this.tabTitles[tabId] : '';
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.settingsParkingPassesService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/settings-parking-passes.component.ts